import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-bookings`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/rent-object-bookings/${id}`);
  },
  async findByIdForBookingCalendar({ id }) {
    return axios.get(`/rent-object-bookings/${id}/minimal`);
  },
  async getDashboard() {
    return axios.get('/rent-object-bookings/dashboard');
  },
  async getChannelRequests() {
    return axios.get('/rent-object-bookings/channel-requests');
  },
  async anonymize({ id }) {
    return axios.get(`/rent-object-bookings/${id}/anonymize`);
  },
  async offerPDFPreview(formData) {
    return axios.post(`/rent-object-bookings/${formData.id}/offer-pdf-preview`, formData, { responseType: 'arraybuffer' });
  },
  async offerMultiplePDFPreview({ offers }) {
    return axios.post(`/rent-object-bookings/offer-multiple-pdf-preview`, {offers}, { responseType: 'arraybuffer' });
  },
  async contractPDFPreview(formData) {
    return axios.post(`/rent-object-bookings/${formData.id}/contract-pdf-preview`, formData, { responseType: 'arraybuffer' });
  },
  async cancelPDFPreview(formData) {
    return axios.post(`/rent-object-bookings/${formData.id}/cancel-pdf-preview`, formData, { responseType: 'arraybuffer' });
  },
  async paymentReminder1PDFPreview(formData) {
    return axios.post(`/rent-object-bookings/${formData.id}/payment-reminder-1-pdf-preview`, formData, { responseType: 'arraybuffer' });
  },
  async paymentReminder2PDFPreview(formData) {
    return axios.post(`/rent-object-bookings/${formData.id}/payment-reminder-2-pdf-preview`, formData, { responseType: 'arraybuffer' });
  },
  async findAll(payload) {
    let url = '/rent-object-bookings';
    if (payload && payload.uuid) url += '/?uuid=STATUS_BOOKING_INTERNET';
    return axios.get(url);
  },
  async findAllByStatus() {
    return axios.get(`/rent-object-bookings`);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-bookings/${id}`);
  },
  async update(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}`, formData);
  },
  async updateCustomer(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}/customer`, formData);
  },
  async updateData(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}/data`, formData);
  },
  async updateComment(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}/comment`, formData);
  },
  async updateReferral(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}/referral`, formData);
  },
  async updateInstantPayment(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}/instant-payment`, formData);
  },
  async updateBookingStatus(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}/booking-status`, formData);
  },
  async updateSignedContract(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}/signed-contract`, formData);
  },
  async updateDisablePaymentReminder(formData) {
    return axios.put(`/rent-object-bookings/${formData.id}/disable-payment-reminder`, formData);
  },
  async findArrivals(formData) {
    return axios.post(`/rent-object-bookings/arrivals`, formData);
  },
  async findDepartures(formData) {
    return axios.post(`/rent-object-bookings/departures`, formData);
  },
  async findCleaningDates(formData) {
    return axios.post(`/rent-object-bookings/cleaning-dates`, formData);
  },
  async findBookingItems(formData) {
    return axios.post(`/rent-object-bookings/booking-items`, formData);
  },
  async findBookingItemsCreatedAt(formData) {
    return axios.post(`/rent-object-bookings/booking-items-created-at`, formData);
  },
  async findAllBookings(formData) {
    const parentContractId = (formData && formData.parentContractId) ? `parentContractId=${formData.parentContractId}` : null;
    const code = (formData && formData.code) ? `code=${formData.code}` : null;
    const lastName = (formData && formData.lastName) ? `lastName=${formData.lastName}` : null;

    const searchString = `?${parentContractId ? '&'+parentContractId : ''}${code ? '&'+code : ''}${lastName ? '&'+lastName : ''}`;
    return axios.post(`/rent-object-bookings/all-bookings/${searchString}`);
  },
  async setCheckIn(formData) {
    return axios.post(`/rent-object-bookings/check-in/${formData.id}`, formData);
  },
  async setCheckOut(formData) {
    return axios.post(`/rent-object-bookings/check-out/${formData.id}`, formData);
  },
  async restore(formData) {
    return axios.put(`/rent-object-bookings/restore/${formData.id}`);
  },
  async calculatePrice(formData) {
    return axios.post('/rent-object-bookings/calculate-price/admin', formData);
  },
  async search(payload) {
    let url = `/rent-object-bookings/search?search=${payload.searchString}`
    return axios.get(url);
  },
  async checkOpenPaymentsAgain({ id }) {
    return axios.get(`/rent-object-bookings/check-payments/${id}`);
  },
  async sendArrivalEmail({ rentObjectBookingId, subject, body }) {
    return axios.post(`/rent-object-bookings/arrival-email`, { rentObjectBookingId, subject, body });
  },
  async archiveArrivalEmail({ rentObjectBookingId }) {
    return axios.get(`/rent-object-bookings/arrival-email/hide/${rentObjectBookingId}`);
  },
};
